import { useState } from "react";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";

export type PasswordInputProps = {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  className?: string;
  dir?: "rtl" | "ltr";
};

export default function PasswordInput({
  value,
  onChange,
  placeholder = "••••••••",
  className = "",
  dir = "rtl",
}: PasswordInputProps) {
  const [show, setShow] = useState(false);
  const isRTL = dir === "rtl";

  return (
    <div className={`relative ${className}`} dir={dir}>
      <input
        type={show ? "text" : "password"}
        className={`w-full rounded-xl border border-gray-300 px-3 py-2 ${
          isRTL ? "pr-10" : "pl-10"
        } focus:outline-none focus:ring-2 focus:ring-gray-300`}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
      />
      <button
        type="button"
        aria-label={show ? "Hide password" : "Show password"}
        onClick={() => setShow((s) => !s)}
        className={`absolute top-1/2 -translate-y-1/2 p-1 text-gray-500 hover:text-gray-700 ${
          isRTL ? "left-2" : "right-2"
        }`}
      >
        {show ? <MdVisibilityOff size={20} /> : <MdVisibility size={20} />}
      </button>
    </div>
  );
}
